<div class="form-input" xmlns="http://www.w3.org/1999/html">
  <label *ngIf="label">{{ label | translate }} <span *ngIf="required">*</span></label>

  <mat-form-field>
    <input matInput
           [id]="name"
           [name]="name"
           [type]="type"
           [placeholder]="(placeholder | translate)"
           [readonly]="readonly"
           [autocomplete]="autocomplete"
           (blur)="onTouched()"
           (input)="onInput($event)"
           [(ngModel)]="value"
           [min]="min"
           [max]="max"
    >
    <mat-icon *ngIf="passwordField"
              class="password-visibility-toggle"
              (click)="toggleVisibility()"
              [fontIcon]="type === 'password' ? 'fa-eye' : 'fa-eye-slash'"
              fontSet="fa"
              matSuffix>
    </mat-icon>
  </mat-form-field>

  <div class="errors" *ngIf="errors">
    @for (error of errors; track error) {
      <span>{{ 'common.form.error.' + error | translate }}</span><br>
    }
  </div>
</div>

